import Component from 'vue-class-component';
import BaseComponent from '@/components/base/BaseComponent';
import { Action, Getter } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  FORM101_OFFICES_LIST,
  FORMS_SEARCH,
  GET_FORM101_OFFICES_LIST,
  GET_FORM101_UNITS_LIST,
} from '@/types/managerForm.types';
import { OfficesModel } from '@/models/Offices.model';

@Component({})
export default class Manager extends BaseComponent {

  @Action(GET_FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public getForm101OfficesList;
  @Action(GET_FORM101_UNITS_LIST, StoreNamespace.MANAGER) public getForm101UnitsList;
  @Action(FORMS_SEARCH, StoreNamespace.MANAGER) public formsSearch;

  @Getter(FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public form101OfficesList!: OfficesModel[];

  public manager: Manager = {} as Manager;

  private taxYear: Array<{ name: string }> = [{ name: '2019' }, { name: '2018' }, { name: '2017' }];

  private offices: Array<{ name: string; value: number }> = [{ name: 'מל"ם שכר 52', value: 1 },
    { name: 'מל"ם שכר 53', value: 2 }, { name: 'מל"ם שכר 54', value: 3 }];

  private unitNumberFrom: Array<{ name: string }> = [{ name: '1587' }, { name: '25879' }, { name: '5555' }];

  private unitNumberTo: Array<{ name: string }> = [{ name: '1587' }, { name: '25879' }, { name: '5555' }];

  private statuses: Array<{ name: string; value: number }> = [{ name: 'נדחה ע"י המעסיק', value: 1 },
    { name: 'אושר ע"י המעסיק', value: 2 }, { name: 'בהמתנה', value: 3 }];

  private filters: Array<{ name: string; value: number }> = [{ name: 'מל"ם שכר 52', value: 1 },
    { name: 'מל"ם שכר 53', value: 2 }, { name: 'מל"ם שכר 54', value: 3 }];

  private formTypes: Array<{ name: string; value: number }> = [{ name: 'אלקטרוני', value: 1 },
    { name: 'ידני', value: 2 }];

  public mounted() {
    this.getForm101OfficesList();
    if (this.form101OfficesList.length) {
      this.getForm101UnitsList(this.form101OfficesList[0]);
    }
  }

  /*public created() {
    /!* Initializing all the objects *!/
    this.manager = {
      lastName: ''
    } as Manager;
  }*/

}

